import React, { useEffect, useContext } from "react";
import { useImmer } from "use-immer";
import { errorMessage, successMessage } from "../../../utils";
import {
  DownloadReportList,
  DownloadReportTableList,
  getWebFeeReport,
  getWebFeeReportExport,
} from "../api";
import { AppContext } from "../../../store/AppScopeProvider";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../../store/AuthProvider";
import { useDebouncedCallback } from "use-debounce";
var fileDownload = require("js-file-download");

const webOrderFeeDefaultColumns = [
  "order_number",
  "order_date",
  "pick_up_date",
  "platform",
  "store_name",
  "grand_total",
  "status",
  "payment_type",
  "web_order_fee_config",
  "web_order_fee",
];

export const useReports = () => {
  const { appState } = useContext(AppContext);
  const { auth } = useContext(AuthContext);
  const { selectedStoreId } = auth.data;
  const { globalData } = appState;
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const [state, setState] = useImmer({
    isLoading: false,
    dataList: [],
    generateData: [],
    columnType: "",
    typeOfView: "order-wise",
    title: "",
    filters: {
      type: "",
      start_date: null,
      end_date: null,
      store_id: [],
      day: [],
      type_of_view: "order-wise",
    },
    webOrderFeeSearchText: "",
    sortBy: [],
    pagination: {
      pageIndex: 1,
      pageSize: 25,
      pageCount: 0,
      total: 0,
      hasMorePages: true,
      lastPage: 1,
    },
    columnOptions: [],
    totals: {},
  });

  console.log("state", state.columnOptions);

  const onChangeFilter = (e, v) => {
    if (["start_date", "end_date"]?.includes(v)) {
      setState((draft) => {
        draft.filters[v] = e;
      });
    } else {
      const { name, value } = e.target;
      if (name === "type") {
        setState((draft) => {
          draft.generateData = [];
        });
      }
      if (value === 9) {
        setState((draft) => {
          draft.filters[name] = value;
          draft.filters.start_date = moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          draft.filters.end_date = moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD");
        });
      } else {
        setState((draft) => {
          draft.filters[name] = value;
        });
      }
    }
  };
  const onClearFilter = (e) => {
    setState((draft) => {
      draft.filters.day = [];
      draft.filters.end_date = null;
      draft.filters.start_date = null;
      draft.filters.store_id = [];
      draft.filters.type = "";
    });
  };

  const onDeleteStoreSelect = (data) => {
    setState((draft) => {
      draft.filters.store_id = [
        ...state.filters.store_id.filter((value) => {
          return value !== data;
        }),
      ];
    });
  };
  const onDeleteDaySelect = (data) => {
    setState((draft) => {
      draft.filters.day = [
        ...state.filters.day.filter((value) => {
          return value !== data;
        }),
      ];
    });
  };
  const handleGenerateReport = async () => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });
      const { type, day, start_date, end_date, store_id } = state.filters;

      let IDs = store_id.map((v) => {
        return v.value;
      });
      let days = day?.map((v) => {
        return v.value;
      });
      let params = {};

      if (type) {
        params = { ...params, type: type };
      }
      if (day?.length > 0) {
        params = { ...params, day: days };
      }
      if (start_date) {
        params = {
          ...params,
          start_date: moment(start_date).format("YYYY-MM-DD"),
        };
      }
      if (end_date) {
        params = {
          ...params,
          end_date: moment(end_date).format("YYYY-MM-DD"),
        };
      }
      if (isStoreAdmin) {
        params = { ...params, store_id: [selectedStoreId] };
      } else if (store_id.length > 0) {
        params = { ...params, store_id: IDs };
      }

      const res = await DownloadReportList(params);
      setState((draft) => {
        draft.generateData = res.data;
        draft.columnType = state?.filters?.type;
        draft.isLoading = false;
      });
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };
  useEffect(() => {
    if (state.filters.type === 4) {
      setState((draft) => {
        draft.filters.day = [];
      });
    }
  }, [state.filters.type]);

  const handleExportTableList = async () => {
    try {
      const { type, day, start_date, end_date, store_id } = state.filters;

      let IDs = store_id.map((v) => {
        return v.value;
      });
      let params = {};

      if (type) {
        params = { ...params, type: type };
      }
      if (day !== null) {
        params = { ...params, day: day };
      }
      if (start_date) {
        params = {
          ...params,
          start_date: moment(start_date).format("YYYY-MM-DD"),
        };
      }
      if (end_date) {
        params = {
          ...params,
          end_date: moment(end_date).format("YYYY-MM-DD"),
        };
      }
      if (isStoreAdmin) {
        params = { ...params, store_id: [selectedStoreId] };
      } else if (store_id.length > 0) {
        params = { ...params, store_id: IDs };
      }
      const res = await DownloadReportTableList(params);
      const content = res.headers["content-type"];
      fileDownload(res.data, `ReportList.xlsx`, content);
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  };

  const onGenerateReport = (e) => {
    if (state.filters.type === "web-order-fee-report") {
      handleWebFeeReport({
        pagination: state.pagination,
        sortBy: state.sortBy,
        search: state.webOrderFeeSearchText,
      });
    } else {
      handleGenerateReport();
    }
  };

  const handleWebFeeReport = async ({ pagination, sortBy = [], search }) => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });
      const { start_date, end_date, store_id, type_of_view } = state.filters;

      let IDs = store_id.map((v) => {
        return v.value;
      });

      let params = {};

      params = { ...params, type: "web-order-fee-report" };
      if (type_of_view) {
        params = { ...params, type_of_view: type_of_view };
      }

      if (start_date) {
        params = {
          ...params,
          start_date: moment(start_date).format("YYYY-MM-DD"),
        };
      }
      if (end_date) {
        params = {
          ...params,
          end_date: moment(end_date).format("YYYY-MM-DD"),
        };
      }
      if (isStoreAdmin) {
        params = { ...params, store_id: [selectedStoreId] };
      } else if (store_id.length > 0) {
        params = { ...params, store_id: IDs };
      }
      if (sortBy.length > 0) {
        const sortByParams = sortBy.reduce(
          (obj, item) =>
            Object.assign(obj, { [item.id]: item.desc ? "desc" : "asc" }),
          {},
        );
        params = {
          ...params,
          sort: sortByParams,
        };
      }
      if (search) {
        params = { ...params, search };
      }

      const res = await getWebFeeReport(params, pagination);

      setState((draft) => {
        draft.generateData = { data: res.data.web_order_fees };
        draft.pagination = res.data.pagination;
        draft.totals = res.data.totals;
        draft.columnType = state?.filters?.type;
        draft.typeOfView = state?.filters?.type_of_view;
        draft.isLoading = false;
      });
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const handleWebFeeReportExport = async () => {
    try {
      let params = {};
      const { start_date, end_date, store_id, type_of_view } = state.filters;
      const columns = webOrderFeeDefaultColumns;
      const visibleColumns = columns.filter(
        (item1) => !state.columnOptions.some((item2) => item1 === item2),
      );
      params = { ...params, columns: visibleColumns };

      let IDs = store_id.map((v) => {
        return v.value;
      });

      params = { ...params, type: "web-order-fee-report" };
      if (type_of_view) {
        params = { ...params, type_of_view: type_of_view };
      }

      params = {
        ...params,
        start_date: start_date ? moment(start_date).format("YYYY-MM-DD") : null,
      };
      params = {
        ...params,
        end_date: end_date ? moment(end_date).format("YYYY-MM-DD") : null,
      };
      if (isStoreAdmin) {
        params = { ...params, store_id: [selectedStoreId] };
      } else {
        params = { ...params, store_id: IDs };
      }

      if (state.webOrderFeeSearchText) {
        params = { ...params, search: state.webOrderFeeSearchText };
      }

      const res = await getWebFeeReportExport(params);
      successMessage(res.message);
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  };

  const handleExport = () => {
    if (state.filters.type === "web-order-fee-report") {
      handleWebFeeReportExport();
    } else {
      handleExportTableList();
    }
  };

  const handleSort = (sortBy) => {
    const { pagination, webOrderFeeSearchText } = state;
    handleWebFeeReport({
      search: webOrderFeeSearchText,
      pagination: {
        pageIndex: 1,
        pageSize: pagination.pageSize,
      },
      sortBy,
    });
    setState((draft) => {
      draft.sortBy = sortBy;
    });
  };

  const gotoPage = (page) => {
    const { pagination, sortBy, webOrderFeeSearchText } = state;
    handleWebFeeReport({
      search: webOrderFeeSearchText,
      pagination: {
        pageIndex: page,
        pageSize: pagination.pageSize,
      },
      sortBy,
    });
    setState((draft) => {
      draft.pagination.pageIndex = page;
    });
  };

  const setPageSize = (e) => {
    const { sortBy, webOrderFeeSearchText } = state;
    handleWebFeeReport({
      search: webOrderFeeSearchText,
      pagination: {
        pageIndex: 1,
        pageSize: +e.target.value,
      },
      sortBy,
    });
    setState((draft) => {
      draft.pagination.pageSize = +e.target.value;
      draft.pagination.pageIndex = 1;
    });
  };

  const debounced = useDebouncedCallback((value) => {
    const { sortBy, pagination } = state;
    handleWebFeeReport({
      search: value,
      pagination: {
        pageIndex: 1,
        pageSize: pagination.pageSize,
      },
      sortBy,
    });
  }, 1000);

  const handleSearch = (v) => {
    setState((draft) => {
      draft.webOrderFeeSearchText = v;
    });
    debounced(v);
  };

  const handleToggleColumnOption = (columns) => {
    setState((draft) => {
      draft.columnOptions = columns;
    });
  };

  return {
    state,
    globalData,
    isStoreAdmin,
    onChangeFilter,
    onClearFilter,
    handleGenerateReport,
    onDeleteStoreSelect,
    handleExportTableList,
    handleExport,
    onDeleteDaySelect,
    onGenerateReport,
    gotoPage,
    setPageSize,
    handleSort,
    handleSearch,
    handleToggleColumnOption,
  };
};
